import { ChangeDetectionStrategy, Component, forwardRef, Injector, Input } from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { BigNumber } from "shared/cubiq-model-multi-asset";
import { RateSpinnerComponent } from "shared/base-components/rate-spinner.component";
import { CcyPairPromiseLookupService } from "shared/cubiq-services";
import { BfxFieldNumberDirective } from "../../../../shared/base-components/bfx-field-number";
import { BfxInputDirective } from "../../../../shared/base-components/bfx-input";
import {
  NUMBER_SPINNER_INPUTS,
  NUMBER_SPINNER_VIEW_PROVIDERS,
} from "../../../../shared/base-components/number-spinner.component";

export const SPINNER_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => BfxPriceSpinnerComponent),
  multi: true,
};

@Component({
  selector: "bfx-price-spinner",
  templateUrl: "../../../../shared/base-components/html/number-spinner.html",
  providers: [SPINNER_VALUE_ACCESSOR],
  viewProviders: NUMBER_SPINNER_VIEW_PROVIDERS,
  inputs: NUMBER_SPINNER_INPUTS,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BfxPriceSpinnerComponent extends RateSpinnerComponent {
  /**********************************************************/
  /* Input parameter config */
  @Input() hideValidation: boolean = false;

  @Input() dead?: boolean = false;

  @Input() deadNeg?: boolean = false;

  constructor(
    injector: Injector,
    inputDirective: BfxInputDirective,
    fieldDirective: BfxFieldNumberDirective,
    currencyPairService: CcyPairPromiseLookupService,
  ) {
    super(injector, inputDirective, fieldDirective, currencyPairService);
  }

  @Input() set inverted(value: boolean) {
    this.isInverted = value;
  }
  get inverted(): boolean {
    return this.isInverted;
  }

  loadValue(value: BigNumber, considerFocus: boolean = false): void {
    //
    // https://www.bcdfx.com/ijira/browse/OMS-35071 Bugfix: Market entry: Market order cannot be submitted when the currency pair is changed with a new one
    // request price spinner update to avoid setting value while the user is editing

    // added to avoid setting request price based on rate (from the panel) while the user is editing
    if (considerFocus && this.componentFocused) return;
    super.loadValue(value);
  }

  /**
   * Override to add new dead* classes which appear to be used in Gamma processing
   */
  protected override updateInputClasses(): void {
    super.updateInputClasses();
    if (this.dead && !this.deadNeg) {
      this.inputClasses.push("dead");
    }
    if (this.deadNeg) {
      this.inputClasses.push("deadNeg");
    }
  }
}
